import styled from 'styled-components';
import { colors, th } from 'style/theme';
import { motion } from 'framer-motion6';
import { ReactComponent as Pin } from 'products/global/assets/img/join-us/pin.svg';
import { sizes } from 'style';

export const VideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100% - 60px);
  background-size: cover;

  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Image = styled.img`
  position: absolute;
  width: 100%;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'calc(100% - 60px)')};
  background-image: ${({ photo }) => `url(${photo})`};
  background-size: cover;
`;

export const ContentWrapper = styled(motion.div)`
  width: 100%;
  height: 100%;
  top: 0;
  background-color: ${th('colors.indigo')};
  z-index: 2;
  position: absolute;

  ::after {
    pointer-events: none;
    display: ${({ $isPlaying }) => ($isPlaying ? 'none' : 'block')};
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 5;
    top: -99%;
    border-radius: 24px 24px 0px 0px;
    background-image: linear-gradient(
      180deg,
      rgba(86, 86, 194, 0) 0%,
      rgba(86, 86, 194, 0.15) 50%,
      ${colors.pickledBluewood} 100%
    );
  }
`;

export const PlayButton = styled.div`
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  z-index: 10;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
  transition: 200ms;
  background: rgba(255, 255, 255, 0.1);

  :hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  padding: 4px 16px 16px 16px;
  display: block;
  line-height: 24px;
  font-size: 16px;
  overflow: scroll;
  scrollbar-width: 0px;
  -webkit-scrollbar-width: 0px;

  @media ${sizes.tabletPortrait} {
    line-height: 26px;
    font-size: 18px;
    padding: 4px 28px 28px 28px;
  }
`;

export const Footer = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: ${colors.pickledBluewood};
  padding: 20px 24px;
  color: white;
  z-index: 3;
  display: flex;
  justify-content: space-between;

  > h1 {
    font-size: 20px;
  }
`;

export const StyledPin = styled(Pin)`
  width: 8px;
  height: 14px;
`;

export const CardContainer = styled(motion.div)`
  overflow: hidden;
  position: relative;
  border-radius: 24px;
  width: 100%;
  padding-bottom: 65%;
  display: flex;
  flex-direction: column;
  width: 500px;

  opacity: ${({ $isCenterSlide }) => ($isCenterSlide ? 1 : 0.5)};
  transition: 0.5s;
  transition-delay: 0.3;

  @media ${sizes.largeDesktop} {
    width: 760px;
  }

  :hover > ${ContentWrapper} {
    transform: translateY(0);
    transition: transform 0.5s ease;
  }
`;
